import { DialogContent } from "@mui/material";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { BottomSheet, Text, type UseModalState } from "@src/appV2/redesign/system/ui-components";

import { CancellationProtectionTermsList } from "./CancellationProtectionTermsList";

interface CancellationProtectionTermsBottomSheetProps {
  modalState: UseModalState;
  cancellationProtectionWindowInHours: number;
  isSentHomeProtected: boolean;
  workplaceName: string;
}

export function CancellationProtectionTermsBottomSheet(
  props: CancellationProtectionTermsBottomSheetProps
) {
  const { modalState, cancellationProtectionWindowInHours, isSentHomeProtected, workplaceName } =
    props;

  return (
    <BottomSheet
      modalState={modalState}
      header={<BottomSheetHeader onClose={() => modalState.closeModal()} />}
      footer={
        <DialogFooter orientation="vertical" sx={{ gap: 7 }}>
          <Text
            variant="caption"
            sx={{
              color: (theme) => theme.palette.text.secondary,
              textAlign: "center",
              paddingX: 6,
            }}
          >
            This term only applies to {workplaceName} and may not apply to other workplaces.
          </Text>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => modalState.closeModal()}
          >
            Great!
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent>
        <CancellationProtectionTermsList
          cancellationProtectionWindowInHours={cancellationProtectionWindowInHours}
          isSentHomeProtected={isSentHomeProtected}
        />
      </DialogContent>
    </BottomSheet>
  );
}
